import { ReactElement } from "react";

import { BaseButton, IBaseButton } from "./BaseButton";

export type ISubmitButton = Omit<IBaseButton, "htmlType">;

export function SubmitButton(props: ISubmitButton): ReactElement<any, any> {
  return <BaseButton {...props} htmlType="submit" />;
}
